import * as React from 'react'

export interface DashProps extends React.HTMLAttributes<HTMLSpanElement> {
  mh?: number
}

export class Dash extends React.Component<DashProps, {}> {
  render() {
    const { mh, ...rest } = this.props
    const marginLeft = mh ? mh : 0
    const marginRight = mh ? mh : 0
    return (
      <span style={{ marginLeft, marginRight }}>
        <span {...rest}>{'\u2014'}</span>
      </span>
    )
  }
}
